import API from "@/api";

export const moduleName = "marketplace";

export const actionTypes = {
  POST_DATA: "POST_DATA",
  EDIT_DATA: "EDIT_DATA",
  GET_DATA: "GET_DATA",
  GET_DATA_BY_ID: "GET_DATA_BY_ID",
  CHANGE_STATUS: "CHANGE_STATUS",
  GET_STATES: "GET_STATES",
  ACTION_UPDATE_MARKETPLACE_CAR: "ACTION_UPDATE_MARKETPLACE_CAR",
  UPLOAD_IMAGE: 'UPLOAD_IMAGE',
  ACTION_REMOVE_CAR_PHOTO: 'ACTION_REMOVE_CAR_PHOTO'
};

export const getterTypes = {
  GETTER_DATA: "GETTER_DATA",
  GETTER_STATES: "GETTER_STATES",
  GETTER_DATA_COUNT: "GETTER_DATA_COUNT",
  GETTER_SELECTED_DATA: "GETTER_SELECTED_DATA",
  GETTER_PAGE_RELOAD: "GETTER_PAGE_RELOAD"
};

export const mutationTypes = {
  SET_STATES: "SET_STATES",
  SET_DATA: "SET_DATA",
  SET_DATA_BY_ID: "SET_DATA_BY_ID",
  MUTATION_SET_PAGE_RELOAD: "MUTATION_SET_PAGE_RELOAD"
};

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    marketplaceData: [],
    marketplaceDataCount: 0,
    selectedData: null,
    isPageReload: false,
    states: []
  }),

  actions: {
    async [actionTypes.UPLOAD_IMAGE]({ commit }, { idx, file, name, carId }) {
      const formData = new FormData()
      formData.append('carImagesExterior', file)
      formData.append("carId", carId)
      const response = await API.marketplaceManager.addMarketplaceItemPhoto(
        formData
      );
      return {
        arrId: idx,
        uploadImageId: response.data.id,
        data: response.data
      }
    },
    async [actionTypes.ACTION_REMOVE_CAR_PHOTO](context, payload) {
      await API.marketplaceManager.deleteCarPhoto.call(this, payload)
    },
    async [actionTypes.POST_DATA]({ commit }, payload) {
      const response = await API.marketplaceManager.postDataToMarketplace(
        payload
      );
      return response.data;
    },
    async [actionTypes.ACTION_UPDATE_MARKETPLACE_CAR]({ commit }, payload) {
      const response = await API.marketplaceManager.editDataByIdMarketplace(
        payload
      );
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, true);

      return response.data;
    },
    async [actionTypes.GET_DATA]({ commit }, payload) {
      const response = await API.marketplaceManager.getDataToMarketplace(
        payload
      );
      const { marketplaceData, marketplaceDataCount } = response.data;
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, false);

      commit(mutationTypes.SET_DATA, [marketplaceData, marketplaceDataCount]);
    },
    async [actionTypes.GET_DATA_BY_ID]({ commit }, payload) {
      const response = await API.marketplaceManager.getDataByIdToMarketplace(
        payload
      );
      const { marketplaceData } = response.data;

      commit(mutationTypes.SET_DATA_BY_ID, [marketplaceData]);
    },
    async [actionTypes.CHANGE_STATUS]({ commit }, payload) {
      const response = await API.marketplaceManager.changeStatus(payload);
      return response.data;
    },
    async [actionTypes.GET_STATES]({ commit }, payload) {
      const response = await API.marketplaceManager.getStates()    
      commit(mutationTypes.SET_STATES, [response.data]);

    }
  },

  mutations: {
    [mutationTypes.SET_DATA](state, [marketplaceData, marketplaceDataCount]) {
      state.marketplaceData = marketplaceData;
      state.marketplaceDataCount = marketplaceDataCount;
    },
    [mutationTypes.SET_DATA_BY_ID](state, [marketplaceData]) {
      state.selectedData = marketplaceData;
    },
    [mutationTypes.SET_STATES](state, [states]) {
      state.states = states;
    },
    [mutationTypes.MUTATION_SET_PAGE_RELOAD](state, pageReload) {
      state.isPageReload = pageReload;
    }
  },

  getters: {
    [getterTypes.GETTER_DATA]: state => state.marketplaceData,
    [getterTypes.GETTER_STATES]: state => state.states,
    [getterTypes.GETTER_DATA_COUNT]: state => state.marketplaceDataCount,
    [getterTypes.GETTER_SELECTED_DATA]: state => state.selectedData,
    [getterTypes.GETTER_PAGE_RELOAD]: (state) => state.isPageReload,

  }
};
